var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_927_7154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3359 17.4704L14.7344 13.0529C15.875 11.7179 16.5625 10.0079 16.5625 8.14414C16.5625 3.86914 12.9492 0.400391 8.49609 0.400391C4.03906 0.400391 0.429688 3.86914 0.429688 8.14414C0.429688 12.4191 4.03906 15.8879 8.49609 15.8879C10.4375 15.8879 12.2148 15.2316 13.6055 14.1366L18.207 18.5504C18.5195 18.8504 19.0234 18.8504 19.3359 18.5504C19.6484 18.2541 19.6484 17.7666 19.3359 17.4704ZM8.49609 14.3466C4.92969 14.3466 2.03125 11.5641 2.03125 8.14414C2.03125 4.72414 4.92969 1.93789 8.49609 1.93789C12.0586 1.93789 14.9609 4.72414 14.9609 8.14414C14.9609 11.5641 12.0586 14.3466 8.49609 14.3466Z",
    fill: "#718EBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_927_7154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.2,
    fill: "white",
    transform: "translate(0 0.400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.6c320cee852c8bc2d1efcaf67f0be1a1.svg";
export { ForwardRef as ReactComponent };